export default class Close extends Phaser.GameObjects.Image {
    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y, 'atlas', 'gui/common/popup_core/icon_close');

        this.setInteractive({ useHandCursor: true });
        this.on('pointerdown', () => this.emit('click'));
    }
}
